import Api from 'src/api/Base'

class GetChangeControlsByCycleId extends Api {
  requestUrl = `/api/Cycle/${this.getParams().cycleId}/ChangeControls`
}
export default GetChangeControlsByCycleId
